import React, {useEffect} from 'react';
import Box from '@material-ui/core/Box/Box';
import Grid from '@material-ui/core/Grid/Grid';
import {useDispatch, useSelector} from 'react-redux';
import GridContainer from '../../../@crema/core/GridContainer';
import AppCard from '../../../@crema/core/AppCard';
import {Fonts} from '../../../shared/constants/AppEnums';
import {IncreasePriceForm} from './IncreasePriceForm';
import {
  fetchPriceIncrease,
  fetchNextPriceIncrease,
} from '../../../redux/actions';
import {
  getIsLoading,
  getNextPriceIncreaseData,
  getPriceIncrease,
} from '../../../redux/selectors';
import {AddBuyPrice} from './AddBuyPrice';

export const IncreasePrice: React.FC = (): React.ReactElement => {
  const dispatch = useDispatch();
  const priceIncrease = useSelector(getPriceIncrease);
  const nextPriceIncrease = useSelector(getNextPriceIncreaseData);
  const isLoading = useSelector(getIsLoading);

  useEffect(() => {
    dispatch(fetchPriceIncrease());
    dispatch(fetchNextPriceIncrease());
  }, []);

  return (
    <Box pt={{md: 4}} mt={{xs: 4, md: 0}}>
      <Box
        component='h2'
        color='text.primary'
        mb={{xs: 4, sm: 4, xl: 6}}
        fontSize={{xs: 18, sm: 20, xl: 22}}
        textAlign={{xs: 'center', sm: 'left'}}
        fontFamily={Fonts.LIGHT}
      >
        Price increase management
      </Box>

      <GridContainer>
        <Grid
          item
          xs={12}
          md={5}
          style={{display: 'flex', flexDirection: 'column'}}
        >
          <AppCard title='Enabled' style={{marginBottom: '1rem'}}>
            <Box
              textAlign={{xs: 'center', sm: 'left'}}
              component='p'
              color='grey.400'
              mb={{xs: 1, md: 3, lg: 5}}
            >
              Aument next price increase
            </Box>

            <Box
              component='span'
              display='block'
              color='primary.main'
              fontFamily={Fonts.EXTRA_BOLD}
              fontSize={{xs: 18, xl: 24}}
            >
              Next price increase (Local time):
              <br /> {nextPriceIncrease.timestamp}
            </Box>

            <Box
              component='span'
              display='block'
              color='primary.main'
              fontFamily={Fonts.EXTRA_BOLD}
              fontSize={{xs: 18, xl: 24}}
            >
              Next price is {nextPriceIncrease.newPrice}
            </Box>
          </AppCard>
          <AppCard title='Add buy price'>
            <AddBuyPrice disabledForm={isLoading} />
          </AppCard>
        </Grid>

        <Grid item sm={7}>
          <AppCard title='Update price increase (Server time in UTC)'>
            <IncreasePriceForm
              disabledForm={priceIncrease.isSaving}
              initialPercentage={
                priceIncrease.data ? priceIncrease.data.percentage : 0
              }
              initialCronValue={
                priceIncrease.data ? priceIncrease.data.cronTimeInterval : ''
              }
            />
          </AppCard>
        </Grid>
      </GridContainer>
    </Box>
  );
};
